<template>
    <div class="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
        <div class="kt-portlet kt-portlet--mobile">
            <div class="kt-portlet__head kt-portlet__head--lg no-border-radius">
                <div class="kt-portlet__head-label">
                </div>
            </div>
            <div class="kt-portlet__body">
                <div class="settings-grid">
                    <router-link v-for="card in visibleCards"
                                 :key="card.key"
                                 :to="{ name: card.route }"
                                 class="settings-card">
                        <div class="settings-card__icon">
                            <img :src="card.icon" :alt="$t(card.label)"
                                 :class="{ 'settings-card__icon-img--wide': card.wide }">
                        </div>
                        <div class="settings-card__text">{{ $t(card.label) }}</div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {mapGetters} from "vuex";
import hasFeatureEnabled from "@/mixins/OrganizationFeatureFlagsMixin";

const icon = name => require(`../../../assets/icons/${name}.svg`);

export default {
    mixins: [hasFeatureEnabled],
    computed: {
        ...mapGetters(['getUserEmail']),
        cards() {
            return [
                {
                    key: 'alerts-dictionary', route: 'alerts-dictionary', icon: icon('icone-alerta'),
                    label: 'AppSettings.Dicionário Alertas', feature: 'ALERTS'
                },
                {
                    key: 'fields', route: 'fields', icon: icon('icone-mapa'),
                    label: 'AppSettings.Locais', feature: 'FIELDS'
                },
                {
                    key: 'operations-center', route: 'operations-center-connection',
                    icon: this.getLogoOperationsCenter(), wide: true,
                    label: 'AppSettings.Sincronizar com Operations Center',
                    feature: 'OPERATIONS_CENTER_CONNECTION'
                },
                {
                    key: 'checklists', route: 'checklists', icon: icon('icone-checklist'),
                    label: 'AppSettings.Checklist', feature: 'APPCONFIGS'
                },
                {
                    key: 'webhook', route: 'webhook', icon: icon('icone-webhook'),
                    label: 'AppSettings.Webhook', feature: 'WEBHOOK'
                },
                {
                    key: 'machine-report', route: 'machine-report', icon: icon('machine-report'),
                    label: 'AppSettings.Máquinas Homologadas', feature: 'AGRICULTURE'
                },
                {
                    key: 'organization-settings', route: 'organization-settings', icon: icon('icone-org-config'),
                    label: 'AppSettings.Configurações da organização', feature: 'ORGANIZATION_SETTINGS'
                },
                {
                    key: 'agro-settings', route: 'agro-settings', icon: icon('icone-agro-settings'),
                    label: 'AppSettings.Preferências agronômicas', feature: 'AGRO_PREFERENCES'
                },
                {
                    key: 'vehicles-group', route: 'vehicles-group', icon: icon('vehicles-group'),
                    label: 'AppSettings.Gerenciar Frentes de trabalho', feature: 'MANAGEMENT_VEHICLES_GROUP'
                },
                {
                    key: 'work-data-upload', route: 'work-data-upload', icon: icon('icone-propeller'),
                    label: 'AppSettings.Upload de Arquivos de Trabalho', feature: 'PROPRIETARY_DATA_TO_SHAPEFILE'
                }
            ];
        },
        visibleCards() {
            return this.cards.filter(card => !card.feature || this.hasFeatureEnabled(card.feature));
        }
    },
    methods: {
        getLogoOperationsCenter() {
            if (process.env.VUE_APP_THEME_ACTIVE === 'IOTAG') {
                return require("../../../assets/icons/icone-john-deere-connected.svg");
            } else if (process.env.VUE_APP_THEME_ACTIVE === 'VIVO' || process.env.VUE_APP_THEME_ACTIVE === 'SOL' || process.env.VUE_APP_THEME_ACTIVE === 'PTXTRIMBLE') {
                return require("../../../assets/icons/icone-john-deere-connected-black.svg");
            } else {
                return require("../../../assets/icons/icone-john-deere-connected-white.svg");
            }
        }
    }
}
</script>

<style scoped lang="scss">

@import "src/assets/styles/constants";

$settings-active: $aside-menu-item-active;

.settings-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 18px;
    padding: 10px 4px;
}

.settings-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 160px;
    padding: 16px 12px;
    background-color: #fff;
    border: 1px solid #e8ecee;
    border-radius: 12px;
    text-decoration: none;
    cursor: pointer;
    transition: border-color .18s ease, box-shadow .18s ease, transform .18s ease;
}

.settings-card:hover {
    border-color: $settings-active;
    box-shadow: 0 6px 18px rgba(0, 0, 0, .08);
    transform: translateY(-3px);
}

.settings-card__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 64px;
}

.settings-card__icon img {
    width: 52px;
    height: 52px;
    object-fit: contain;
    filter: $aside-menu-item-inactive;
    transition: filter .18s ease;
}

/* the Operations Center brand logo is a wide image, not a 52px icon */
.settings-card__icon img.settings-card__icon-img--wide {
    width: auto;
    max-width: 130px;
    height: 48px;
    filter: none;
}

.settings-card__text {
    margin-top: 10px;
    font-size: 14px;
    line-height: 1.25;
    text-align: center;
    color: $aside-menu-text;
}

</style>
